import crud from '@/crud/form/form'
import resources from '../../resources'

import computed from './computed'
import methods from './methods'
import validations from './validations'
import mounted from './mounted'

export default {
  computed,
  methods,
  validations,
  mounted,

  mixins: [crud, resources]
}



// WEBPACK FOOTER //
// ./src/app/professional/agenda/locks/form/resources/index.js